<template>
  <div class="homeContainer" v-if="dataReady" :style="bgColorStyle">
    <!-- 顶部导航按钮 -->
    <PinnedBtnContainer>
      <component
        v-for="pinnedBtnObj in pinnedBtnComponentObjs"
        :key="pinnedBtnObj.id"
        :is="pinnedBtnObj.component"
        v-bind="pinnedBtnObj.props"
        @reportEvent="handleReport"
      ></component>
    </PinnedBtnContainer>
    <!-- 模板头图 -->
    <Banner :imgUrl="tplData.pageConfig.headImage" />
    <Main
      :bgImgUrl="tplData.pageConfig.backgroundImage"
      :bgColor="tplData.pageConfig.backgroundColor"
    >
      <!-- 流式布局组件 -->
      <FlowComponentContainer
        v-for="flowObj in flowComponentObjs"
        :key="flowObj.id"
        :hasGap="flowObj.hasGap"
      >
        <component
          :is="flowObj.component"
          v-bind="flowObj.props"
          @reportEvent="handleReport"
          :moduleName="moduleName"
        />
      </FlowComponentContainer>
    </Main>
    <!-- 固定定位组件 -->
    <component
      v-for="positionObj in positionComponentObjs"
      :key="positionObj.id"
      :is="positionObj.component"
      v-bind="positionObj.props"
      @reportEvent="handleReport"
    />
    <Alert :show="disabled" noClose="true">
      <div class="errorToast">请到货拉拉企业版APP参与活动哦~</div>
    </Alert>
  </div>
</template>

<script>
import { isRiskError, isNotMatchUserRange } from '../../helper';
import Main from '../components/Main';
import PinnedBtnContainer from '../../common/PinnedBtnContainer';
import FlowComponentContainer from '@/components/templates/common/FlowComponentContainer';
import { mapActions, mapState, mapMutations } from 'vuex';
import Banner from '@/components/templates/common/Banner';
import Alert from '@u/Alert';
import { isHllApp } from '@/utils';

export default {
  components: {
    PinnedBtnContainer,
    Banner,
    FlowComponentContainer,
    Main,
    Alert
  },
  props: {
    actCode: String,
    moduleName: String
  },
  data() {
    return {
      disabled: false
    };
  },
  computed: {
    ...mapState('app', {
      actData: function(state) {
        return state[this.moduleName].actData;
      },
      tplData: function(state) {
        return this.tplDataProp || state[this.moduleName].tplData;
      },
      positionComponentObjs: function(state) {
        return state[this.moduleName].positionComponentObjs;
      },
      flowComponentObjs: function(state) {
        return state[this.moduleName].flowComponentObjs;
      },
      pinnedBtnComponentObjs: function(state) {
        return state[this.moduleName].pinnedBtnComponentObjs;
      }
    }),
    dataReady() {
      return this.actData;
    },
    bgColorStyle() {
      if (
        this.tplData &&
        this.tplData.pageConfig &&
        this.tplData.pageConfig.backgroundColor
      ) {
        return {
          backgroundColor: this.tplData.pageConfig.backgroundColor
        };
      }
      return {};
    }
  },
  methods: {
    ...mapActions('app', {
      getActData: function(dispatch, ...props) {
        return dispatch(`${this.moduleName}/getActData`, ...props);
      }
    }),
    ...mapMutations('app', {
      initSetActCode: function(commit, actCode) {
        return commit(`${this.moduleName}/initSetActCode`, actCode);
      }
    }),
    async initPage() {
      try {
        await this.getActData(this.actCode);
      } catch (error) {
        // 命中风控处理
        if (isRiskError(error.ret)) {
          this.$router.replace('/account_error');
          return;
        }
        // 未命中人群
        if (isNotMatchUserRange(error.ret)) {
          this.$router.replace('/not_match');
          return;
        }
        this.$hll.toast(error && error.msg);
        return;
      }
    },
    handleReport(data) {
      const { event, ...fields } = data;
      this.visitLog('', '', {
        ...fields,
        actEventType: event,
        activity_code: this.actCode
      });
    },
    setTitle() {
      const actName = this.tplData.pageConfig && this.tplData.pageConfig.name;
      if (actName) {
        document.title = actName;
      }
    }
  },
  async created() {
    if (!isHllApp()) {
      this.disabled = true;
    }
    await this.initSetActCode(this.actCode);
    await this.initPage();
    await this.setTitle();
  }
};
</script>

<style lang="less" scoped>
.homeContainer {
  padding-bottom: 160px;
}
.errorToast {
  height: 431px;
  font-size: 32px;
  color: #000;
  .fc;
}
</style>
